import { render, staticRenderFns } from "./ModalCreateGroup.vue?vue&type=template&id=645c2450&"
import script from "./ModalCreateGroup.vue?vue&type=script&lang=js&"
export * from "./ModalCreateGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateGroup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports